export const GET_CACHE = 'GET_CACHE';

export const SET_USER_INFO = 'SET_USER_INFO';

export const PLAY_GAME = 'PLAY_GAME';

export const END_GAME = 'END_GAME';

export const INVITE = 'INVITE';

export const SWITCH_MUSIC = 'SWITCH_MUSIC';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js